import React from 'react'
import './styles/styles.css'
import {
  EditCellRenderer,
  DeleteCellRenderer,
  ProxyCellRenderer,
  FirstNameFilter,
  LastNameFilter,
  ExtraField1Filter,
  ExtraField2Filter,
  LastLoginFilter,
  EmailFilter,
  UsernameFilter,
  RolesFilter,
  AccessFilter,
  StoreFilter,
  StatusFilter,
  LocationGroupsFilter,
  ExternalIdFilter,
  ArchivedFilter,
} from './Filters'

export const formatAdminColumns = (users, id, storeData, language) => {
  // const language =
  //   languageData && languageData.language ? languageData.language.data : {};
  console.log(language, 'leart26')

  const groups = []
  const roles = []
  const stores = []
  users.map((item) => {
    item.groups.map((groupItem) => {
      if (groups.indexOf(groupItem) === -1) {
        groups.push(groupItem)
      }
    })

    item.stores.map((storeItem) => {
      if (stores.indexOf(storeItem) === -1) {
        stores.push(storeItem)
      }
    })

    item.user_roles.map((roleItem) => {
      if (roles.indexOf(roleItem) === -1) {
        roles.push(roleItem)
      }
    })
  })

  let rolesFilterOptions = ['empty']
  roles.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
      hideFilterInput: true,
    }
    rolesFilterOptions.push(data)
  })

  return [
    {
      headerName: '',
      field: 'edit',
      pinned: 'right',
      width: 30,
      suppressMovable: true,
      cellRenderer: EditCellRenderer,
    },
    {
      headerName: '',
      field: 'delete',
      pinned: 'right',
      width: 30,
      suppressMovable: true,
      cellRenderer: DeleteCellRenderer,
    },
    {
      headerName: '',
      field: 'proxy',
      pinned: 'right',
      width: 30,
      suppressMovable: true,
      cellRenderer: function (params) {
        if (params.data.id === id) {
          return <div></div>
        }
        return <ProxyCellRenderer />
      },
    },
    {
      headerName: 'First Name',
      field: 'first_name',
      resizable: true,
      width: 125,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'first_name',
      filter: FirstNameFilter,
    },
    {
      headerName: 'Last Name',
      field: 'last_name',
      resizable: true,
      width: 125,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'last_name',
      filter: LastNameFilter,
    },
    {
      headerName: 'Extra field 1*',
      field: 'extra_field_1',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      tooltipField: 'extra_field_1',
      filter: ExtraField1Filter,
    },
    {
      headerName: 'Extra field 2*',
      field: 'extra_field_2',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      tooltipField: 'extra_field_2',
      filter: ExtraField2Filter,
    },
    {
      headerName: 'Email',
      field: 'email',
      resizable: true,
      tooltipField: 'email',
      filter: EmailFilter,
    },
    {
      headerName: 'Username',
      field: 'username',
      resizable: true,
      tooltipField: 'username',
      filter: UsernameFilter,
    },
    {
      headerName: 'Employee Id',
      field: 'external_id',
      resizable: true,
      tooltipField: 'external_id',
      filter: ExternalIdFilter,
    },
    {
      headerName: 'Locations',
      field: 'stores',
      resizable: true,
      tooltipField: 'stores',
      suppressSizeToFit: true,
      tooltipField: 'stores',
      filter: StoreFilter,
    },
    {
      headerName: 'Roles',
      field: 'user_roles',
      resizable: true,
      tooltipField: 'user_roles',
      filter: RolesFilter,
    },
    {
      headerName: 'Access',
      field: 'access',
      resizable: true,
      tooltipField: 'access',
      accessOptions: [
        {
          access: 1,
          name: language.settings ? language.settings.admin : 'Admin',
        },
        {
          access: 4,
          name: language.settings ? language.settings.area_admin : 'Area Admin',
        },
        {
          access: 2,
          name: language.settings
            ? language.settings.course_manager
            : 'Course Manager',
        },
        {
          access: 3,
          name: language.settings ? language.settings.employee : 'Employee',
        },
        { access: 5, name: 'Region Manager' },
      ],
      filter: AccessFilter,
    },
    {
      headerName: 'Status',
      field: 'status',
      resizable: true,
      tooltipField: 'status',
      filter: StatusFilter,
    },
    {
      headerName: 'Archived',
      field: 'archived',
      resizable: true,
      tooltipField: 'archived',
      filter: ArchivedFilter,
    },
    {
      headerName: 'Location Groups',
      field: 'groups',
      resizable: true,
      tooltipField: 'groups',
      suppressSizeToFit: true,
      filter: LocationGroupsFilter,
    },
    {
      headerName: 'Last Login',
      field: 'last_login',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      tooltipField: 'last_login',
      // filter: 'lastLoginFilter'
      filter: false,
    },
    {
      headerName: 'Last Activity',
      field: 'last_activity',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      tooltipField: 'last_activity',
      // filter: 'lastLoginFilter'
      filter: false,
    },
  ]
}

export const formatAreaAdminColumns = (users, language) => {
  const groups = []
  const roles = []
  const stores = []

  // const language =
  //   languageData && languageData.language ? languageData.language.data : {};

  users.map((item) => {
    item.groups.map((groupItem) => {
      if (groups.indexOf(groupItem) === -1) {
        groups.push(groupItem)
      }
    })

    item.stores.map((storeItem) => {
      if (stores.indexOf(storeItem) === -1) {
        stores.push(storeItem)
      }
    })

    item.user_roles.map((roleItem) => {
      if (roles.indexOf(roleItem) === -1) {
        roles.push(roleItem)
      }
    })
  })

  let groupFilterOptions = ['empty']
  groups.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
      hideFilterInput: true,
    }
    groupFilterOptions.push(data)
  })

  let rolesFilterOptions = ['empty']
  roles.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
      hideFilterInput: true,
    }
    rolesFilterOptions.push(data)
  })

  let storesFilterOptions = ['empty']
  stores.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
      hideFilterInput: true,
    }
    storesFilterOptions.push(data)
  })

  return [
    {
      headerName: '',
      field: 'edit',
      pinned: 'right',
      width: 40,
      suppressMovable: true,
      cellRendererFramework: EditCellRenderer,
    },
    {
      headerName: 'First Name',
      field: 'first_name',
      resizable: true,
      width: 140,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'first_name',
      filter: FirstNameFilter,
    },
    {
      headerName: 'Last Name',
      field: 'last_name',
      resizable: true,
      width: 140,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'last_name',
      filter: LastNameFilter,
    },
    {
      headerName: `${'Extra field 1*'}`,
      // headerName:''
      field: 'extra_field_1',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'extra_field_1',
      filter: ExtraField1Filter,
    },
    {
      headerName: 'Extra_field_2*',
      field: 'extra_field_2',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'extra_field_2',
      filter: ExtraField2Filter,
    },
    {
      headerName: 'Last_Login*',
      field: 'last_login',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'last_login',
      filter: LastLoginFilter,
    },
    {
      headerName: 'Last Activity*',
      field: 'last_activity',
      resizable: true,
      width: 120,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'last_activity',
      filter: LastLoginFilter,
    },
    {
      headerName: 'Email',
      field: 'email',
      resizable: true,
      tooltipField: 'email',
      filter: EmailFilter,
    },
    {
      headerName: 'Username',
      field: 'username',
      resizable: true,
      tooltipField: 'username',
      filter: UsernameFilter,
    },
    {
      headerName: 'Employee Id',
      field: 'external_id',
      resizable: true,
      tooltipField: 'external_id',
      filter: ExternalIdFilter,
    },
    {
      headerName: 'Locations',
      field: 'stores',
      resizable: true,
      tooltipField: 'stores',
      suppressSizeToFit: true,
      tooltipField: 'stores',
      filter: StoreFilter,
    },
    {
      headerName: 'Roles',
      field: 'user_roles',
      resizable: true,
      tooltipField: 'user_roles',
      filter: RolesFilter,
    },
    {
      headerName: 'Access',
      field: 'access',
      resizable: true,
      tooltipField: 'access',
      accessOptions: [
        {
          access: 1,
          name: language.settings ? language.settings.admin : 'Admin',
        },
        {
          access: 4,
          name: language.settings ? language.settings.area_admin : 'Area Admin',
        },
        {
          access: 2,
          name: language.settings
            ? language.settings.course_manager
            : 'Course Manager',
        },
        {
          access: 3,
          name: language.settings ? language.settings.employee : 'Employee',
        },
        { access: 5, name: 'Region Manager' },
      ],
      filter: AccessFilter,
    },
    {
      headerName: 'Status',
      field: 'status',
      resizable: true,
      tooltipField: 'status',
      filter: StatusFilter,
    },
    {
      headerName: 'Location Groups',
      field: 'groups',
      resizable: true,
      tooltipField: 'groups',
      suppressSizeToFit: true,
      filter: LocationGroupsFilter,
    },
  ]
}

export const formatCourseManagerColumns = (
  users,
  language,
  managerCanEditUser
) => {
  const roles = []
  const stores = []

  // const language =
  //   languageData && languageData.language ? languageData.language.data : {};

  users.map((item) => {
    item.stores.map((storeItem) => {
      if (stores.indexOf(storeItem) === -1) {
        stores.push(storeItem)
      }
    })

    item.user_roles.map((roleItem) => {
      if (roles.indexOf(roleItem) === -1) {
        roles.push(roleItem)
      }
    })
  })

  let rolesFilterOptions = ['empty']
  roles.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
      hideFilterInput: true,
    }
    rolesFilterOptions.push(data)
  })

  let storesFilterOptions = ['empty']
  stores.map((item) => {
    const data = {
      displayKey: item,
      displayName: item,
      test: function (filterValue, cellValue) {
        return cellValue.toLowerCase().indexOf(item.toLowerCase()) !== -1
      },
    }
    storesFilterOptions.push(data)
  })
  return [
    managerCanEditUser === 1 && {
      headerName: '',
      field: 'edit',
      pinned: 'right',
      width: 40,
      suppressMovable: true,
      cellRendererFramework: EditCellRenderer,
    },
    {
      headerName: 'First Name',
      field: 'first_name',
      resizable: true,
      minWidth: 140,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'first_name',
      filter: FirstNameFilter,
    },
    {
      headerName: 'Last Name',
      field: 'last_name',
      resizable: true,
      minWidth: 140,
      suppressSizeToFit: true,
      pinned: 'left',
      tooltipField: 'last_name',
      filter: LastNameFilter,
    },
    {
      headerName: 'Email',
      field: 'email',
      resizable: true,
      tooltipField: 'email',
      filter: EmailFilter,
    },
    {
      headerName: 'Username',
      field: 'username',
      resizable: true,
      tooltipField: 'username',
      filter: UsernameFilter,
    },
    {
      headerName: 'Employee Id',
      field: 'external_id',
      resizable: true,
      tooltipField: 'external_id',
      filter: ExternalIdFilter,
    },
    {
      headerName: 'Locations',
      field: 'stores',
      resizable: true,
      tooltipField: 'stores',
      suppressSizeToFit: true,
      tooltipField: 'stores',
      filter: StoreFilter,
    },
    {
      headerName: 'Roles',
      field: 'user_roles',
      resizable: true,
      tooltipField: 'user_roles',
      filter: RolesFilter,
    },
    {
      headerName: 'Access',
      field: 'access',
      resizable: true,
      tooltipField: 'access',
      accessOptions: [
        {
          access: 1,
          name: language.settings ? language.settings.admin : 'Admin',
        },
        {
          access: 4,
          name: language.settings ? language.settings.area_admin : 'Area Admin',
        },
        {
          access: 2,
          name: language.settings
            ? language.settings.course_manager
            : 'Course Manager',
        },
        {
          access: 3,
          name: language.settings ? language.settings.employee : 'Employee',
        },
        { access: 5, name: 'Region Manager' },
      ],
      filter: AccessFilter,
    },
    {
      headerName: 'Status',
      field: 'status',
      resizable: true,
      tooltipField: 'status',
      filter: StatusFilter,
    },
  ]
}

export const formatRows = (users, access, isProxied, language) => {
  let rows = []
  if (users.length) {
    users.map((item) => {
      rows.push({
        id: item.id,
        edit: 'Edit',
        delete: 'Delete',
        proxy: 'Proxy',
        first_name: item.first_name,
        last_name: item.last_name,
        extra_field_1: item.extra_field_1,
        extra_field_2: item.extra_field_2,
        last_login: item.last_login,
        last_activity: item.last_activity,
        email: item.email,
        username: item.username,
        access:
          item.access === 1
            ? language.settings
              ? language.settings.admin
              : 'Admin'
            : item.access === 2
            ? language.settings
              ? language.settings.course_manager
              : 'Course Manager'
            : item.access === 4
            ? language.settings
              ? language.settings.area_admin
              : 'Area Admin'
            : item.access === 5
            ? 'region_manager'
            : language.settings
            ? language.settings.employee
            : 'Employee',
        status:
          item.status === '1'
            ? 'Active'
            : item.status === '2'
            ? 'Term'
            : 'Leave of Absence',
        archived: item.archived ? 'Yes' : 'No',
        groups: item.groups.map((subItem) => subItem),
        stores: item.stores.map((subItem) => subItem),
        user_roles: item.user_roles.map((subItem) => subItem),
        external_id: item.external_id,
      })
    })
    return rows
  }
}
